export default __webpack_public_path__ + "static/media/item_2@3x.491330e2.webp";